import { getLogger } from './debug-logger';

export const quietError = getLogger('bl-admin:internal-errors', '#f54248');
